import React from 'react';
import classNames from 'classnames';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import EnhancedTableHead from '../../utils/EnhancedTableHead';
import { commonTablestyles } from '../../utils/Style';
import ReactTable from 'react-table';
import '../../css/react-table/react-table.css';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        
        marginRight: "auto",
        color: "green"
    }
});
class TriggeredNotifyTable extends React.Component {

    
  columns = [  {
                
    "Header": "ID",
    Cell : props => props.index + 1
},
    {
     
    "Header": "Date Created",
    "accessor": 'datetime_created', 
    }, 
    {
    "Header": "Company",
    "accessor": 'companyName', 
    },
    {
    "Header": "Type",
    "accessor": 'type', 
    },
    {
        "Header": "MODIS",
        "accessor":'raw_modis_geom',  
     },
     {
        "Header": "VIIRS",
        "accessor": "raw_viirs_geom", 
    },
    {
       "Header": "Is Peat",
       "accessor": "isPeat", 
       Cell: props => (props.value) ? "Yes": "No"
   },
   {
      "Header": "Is Protected",
      "accessor": "isProtected", 
      Cell: props => (props.value) ? "Yes": "No"
  },
  {
     "Header": "Is RSPO",
     "accessor": "isNonRspo", 
     Cell: props => (props.value) ? "No": "Yes"
 },
    {
        "Header": "Status",
        "accessor": "status",
    },
    
    {
        "Header": "Action",
        "accessor": "action",
        minWidth:300,
        Cell: props => <Button  variant="contained"
        color="primary" onClick={()=>this.submitClick(props.row.user_geom_id)}>View in map</Button>
    }];
     
    submitClick=(value)=>{ 
    }

    state = {
        open: false,
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            objects: [],
            selected: [],
            data:this.props.data,
            order: 'asc',
            orderBy: '',
            page: 0,
        };
    }

    componentWillMount() {
        this.setState({ objects: this.props.objects });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ selected: nextProps.selected });
        //this.setState({ page: nextProps.page }); 
        if (nextProps.data != this.state.data) {
            this.setState({ data: nextProps.data });
        }
    } 
 
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    renderReactTable(data,classes,columns){
        return (
            <Paper>
                <Grid container className={classes.root}>
                    <Grid item xs={12}>
                        <Grid container justify='center' alignItems='center'>
                            Filtered List

                        </Grid>
                        <Grid container justify='center' alignItems='center'>
                            <ReactTable 
                                className="-striped -highlight"
                                defaultPageSize={100}
                                data={ data}
                                columns={columns}
                                style={{width:'98%'}}
                            >
                            </ReactTable>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        );
    }

    render() {
        const { classes, columnData, handleChangeRowsPerPage, handleModalOpen, handleChangePage, countuserValue, rowsPerPage, emptyRows, selected, handleClick, handleSelectAllClick } = this.props;
        const { objects, order, orderBy, page,data } = this.state;
        return (
           
        this.renderReactTable( data, classes, this.columns)
        );
    }
}

export default withStyles(commonTablestyles)(TriggeredNotifyTable);


// WEBPACK FOOTER //
// ./src/utils/MainTable/TriggeredNotifyTable.js